import { React, useEffect, useState } from "react";
import { ReactComponent as UploadIcon } from "../../../assets/images/uploadIcon.svg";
import { Box, Button, Typography } from "@mui/material";
import InputAdornment from "@mui/material/InputAdornment";
import { useFormik } from "formik";
import CustomInput from "../../CustomInput/CustomInput";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import * as Yup from "yup";
import {
  setAgentSignupData,
  setAgentSignupStepCount,
} from "../../../redux/login";
import { ReactComponent as GoBackIcon } from "../../../assets/svg/arrow_back_icon.svg";
import { ReactComponent as CloseIcon } from '../../../assets/svg/icons8-close.svg';
import {
  setAgentAddressProof,
  setAgentTaxProof,
  setAgentIdProof,
} from "../../../redux/login";
import { toast } from "react-toastify";
import { loginItemsSelector } from "../../../redux/login";

const UploadDocuments = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { agentSignUpData } = useSelector(loginItemsSelector);
  const [uploadedIdProof, setUploadedIdProof] = useState(null);
  const [idFileName, setIdFileName] = useState("");
  const [addressFileName, setAddressFileName] = useState("");
  const [taxFileName, setTaxFileName] = useState("");
  const [uploadedAddressProof, setUploadedAddressProof] = useState(null);
  const [uploadedTaxProof, setUploadedTaxProof] = useState(null);
  const [idProofDoc, setIdProofDoc] = useState(true);
  const [addressProofDoc, setAddressProofDoc] = useState(true);
  const [taxProofDoc, setTaxProofDoc] = useState(true);

  const MAX_DOCUMENT_SIZE = 10 * 1024 * 1024; // 10MB
  const ACCEPTED_EXTENSIONS = /\.(pdf|jpe?g|png)$/i;
  const DISALLOWED_EXTENSIONS = /\.(zip|exe|bat|cmd|sh|js|jar|iso)$/i;

  const validateDocumentFile = (file, label) => {
    if (!file) return false;
    const fileName = file.name || "";

    if (DISALLOWED_EXTENSIONS.test(fileName)) {
      toast.error(`${label} cannot be a ZIP or executable file.`, {
        autoClose: 2500,
      });
      return false;
    }

    if (!ACCEPTED_EXTENSIONS.test(fileName)) {
      toast.error(`${label} must be a PDF, JPG, JPEG, or PNG file.`, {
        autoClose: 2500,
      });
      return false;
    }

    if (file.size > MAX_DOCUMENT_SIZE) {
      toast.error(`${label} must be 10 MB or smaller.`, {
        autoClose: 2500,
      });
      return false;
    }

    return true;
  };

  const handleLogin = (values) => {
    // console.log('val upl doc', event)
    // alert("hey");
  };

  const formik = useFormik({
    initialValues: {
      id_proof: "",
      address_proof: "",
      tax_proof: "",
    },
    validationSchema: Yup.object({
      // id_proof: Yup.string().required("Please Upload ID Proof"),
      // address_proof: Yup.string().required("Please Upload Address Proof"),
      // tax_proof: Yup.string().required("Please Upload Tax Proof "),
    }),
    onSubmit: handleLogin,
  });

  const handleIdProofFileChange = (event) => {
    setIdProofDoc(true);
    const file = event.target.files[0];
    if (!file) {
      setIdFileName("");
      setUploadedIdProof(null);
      return;
    }

    if (!validateDocumentFile(file, "ID proof")) {
      setIdFileName("");
      setUploadedIdProof(null);
      event.target.value = null;
      return;
    }

    setIdFileName(file.name);
    setUploadedIdProof(file);
    formik.setFieldValue("id_proof", file);
  };
  const handleAddressProofFileChange = (event) => {
    setAddressProofDoc(true);
    const file = event.target.files[0];
    if (!file) {
      setAddressFileName("");
      setUploadedAddressProof(null);
      return;
    }

    if (!validateDocumentFile(file, "Address proof")) {
      setAddressFileName("");
      setUploadedAddressProof(null);
      event.target.value = null;
      return;
    }

    setAddressFileName(file.name);
    setUploadedAddressProof(file);
  };
  const handleTaxProofFileChange = (event) => {
    setTaxProofDoc(true);
    const file = event.target.files[0];
    if (!file) {
      setTaxFileName("");
      setUploadedTaxProof(null);
      return;
    }

    if (!validateDocumentFile(file, "Tax proof")) {
      setTaxFileName("");
      setUploadedTaxProof(null);
      event.target.value = null;
      return;
    }

    setTaxFileName(file.name);
    setUploadedTaxProof(file);
  };

  const handleUploadDocument = () => {
    if (uploadedIdProof && uploadedAddressProof && uploadedTaxProof) {
      const tempObj = { ...agentSignUpData?.items };
      const newObj = {
        ...tempObj,
        uploadedIdProof: uploadedIdProof,
        uploadedAddressProof: uploadedAddressProof,
        uploadedTaxProof: uploadedTaxProof,
      };
      dispatch(setAgentSignupData({ ...newObj }));
      const agentSignupData = JSON.parse(
        localStorage?.getItem("agent_signup_data") || "{}"
      );
      if (agentSignupData) {
        localStorage?.setItem(
          "agent_signup_data",
          JSON.stringify(newObj || {})
        );
        dispatch(setAgentSignupStepCount(3));
      }
    } else {
      toast.error("Please Upload Docs", {
        autoClose: 2500,
      });
    }
  };
  useEffect(() => {
    const savedData = agentSignUpData?.items || {};

    if (savedData.uploadedIdProof) {
      setUploadedIdProof(savedData.uploadedIdProof);
      setIdFileName(savedData.uploadedIdProof?.name || "Uploaded file");
    }
    if (savedData.uploadedAddressProof) {
      setUploadedAddressProof(savedData.uploadedAddressProof);
      setAddressFileName(savedData.uploadedAddressProof?.name || "Uploaded file");
    }
    if (savedData.uploadedTaxProof) {
      setUploadedTaxProof(savedData.uploadedTaxProof);
      setTaxFileName(savedData.uploadedTaxProof?.name || "Uploaded file");
    }
  }, [agentSignUpData]);

  useEffect(() => {
    dispatch(setAgentIdProof(uploadedIdProof));
    dispatch(setAgentAddressProof(uploadedAddressProof));
    dispatch(setAgentTaxProof(uploadedTaxProof));
  }, [dispatch, uploadedIdProof, uploadedAddressProof, uploadedTaxProof]);
  const closeIdProof = () => {
    setIdProofDoc(false);
  }
  const closeAddressProof = () => {
    setAddressProofDoc(false);
  }
  const closeTaxProof = () => {
    setTaxProofDoc(false);
  }

  return (
    <>
      <Box sx={{ px: 5, pt: 3, background: '#FFFFFF' }}>
        <Button
          onClick={() => dispatch(setAgentSignupStepCount(1))}
          sx={{
            minWidth: 'auto',
            p: 1,
            mb: 2,
            borderRadius: '50%',
            color: '#64748B',
            '&:hover': { background: '#F1F5F9', color: '#0085FD' }
          }}
        >
          <GoBackIcon style={{ width: 24, height: 24 }} />
        </Button>

        <form onSubmit={formik.handleSubmit} noValidate>
          <Typography
            sx={{
              fontWeight: 700,
              fontSize: "1.75rem",
              color: "#1E293B",
              fontFamily: "Outfit, sans-serif",
              textAlign: 'center',
              width: '100%',
              mb: 1
            }}
          >
            {t("AgentRegistration.Agent_Registration")}
          </Typography>
          <Typography
            sx={{
              fontSize: "0.875rem",
              color: "#64748B",
              textAlign: "center",
              mb: 4
            }}
          >
            {t("AgentRegistration.Upload_Documents")}
          </Typography>

          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, mb: 5 }}>
            <Box>
              <CustomInput
                variant="outlined"
                fullWidth
                label={t("AgentRegistration.ID_Proof") + "*"}
                placeholder={t("AgentRegistration.ID_Proof")}
                InputLabelProps={{ shrink: true }}
                sx={{ '& .MuiOutlinedInput-root': { borderRadius: '10px' } }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <UploadIcon style={{ fill: '#0085FD' }} />
                    </InputAdornment>
                  ),
                }}
                name="id_proof"
                type="file"
                accept=".pdf,.jpg,.jpeg,.png"
                onChange={handleIdProofFileChange}
                onClick={e => (e.target.value = null)}
              />
              {idFileName && idProofDoc && (
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 0.5, px: 1 }}>
                  <Typography sx={{ fontSize: "0.8125rem", color: '#0085FD', fontWeight: 500 }}>
                    {idFileName}
                  </Typography>
                  <CloseIcon
                    onClick={closeIdProof}
                    style={{ width: 16, height: 16, cursor: "pointer", color: '#64748B' }}
                  />
                </Box>
              )}
            </Box>

            <Box>
              <CustomInput
                variant="outlined"
                fullWidth
                label={t("AgentRegistration.Address_Proof") + "*"}
                placeholder={t("AgentRegistration.Address_Proof")}
                InputLabelProps={{ shrink: true }}
                sx={{ '& .MuiOutlinedInput-root': { borderRadius: '10px' } }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <UploadIcon style={{ fill: '#0085FD' }} />
                    </InputAdornment>
                  ),
                }}
                name="address_proof"
                type="file"
                accept=".pdf,.jpg,.jpeg,.png"
                onChange={handleAddressProofFileChange}
                onClick={e => (e.target.value = null)}
              />
              {addressFileName && addressProofDoc && (
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 0.5, px: 1 }}>
                  <Typography sx={{ fontSize: "0.8125rem", color: '#0085FD', fontWeight: 500 }}>
                    {addressFileName}
                  </Typography>
                  <CloseIcon
                    onClick={closeAddressProof}
                    style={{ width: 16, height: 16, cursor: "pointer", color: '#64748B' }}
                  />
                </Box>
              )}
            </Box>

            <Box>
              <CustomInput
                variant="outlined"
                fullWidth
                label={t("AgentRegistration.Tax_Proof") + "*"}
                placeholder={t("AgentRegistration.Tax_Proof")}
                InputLabelProps={{ shrink: true }}
                sx={{ '& .MuiOutlinedInput-root': { borderRadius: '10px' } }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <UploadIcon style={{ fill: '#0085FD' }} />
                    </InputAdornment>
                  ),
                }}
                name="tax_proof"
                type="file"
                accept=".pdf,.jpg,.jpeg,.png"
                onChange={handleTaxProofFileChange}
                onClick={e => (e.target.value = null)}
              />
              {taxFileName && taxProofDoc && (
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 0.5, px: 1 }}>
                  <Typography sx={{ fontSize: "0.8125rem", color: '#0085FD', fontWeight: 500 }}>
                    {taxFileName}
                  </Typography>
                  <CloseIcon
                    onClick={closeTaxProof}
                    style={{ width: 16, height: 16, cursor: "pointer", color: '#64748B' }}
                  />
                </Box>
              )}
            </Box>
          </Box>

          <Button
            onClick={handleUploadDocument}
            variant="contained"
            disableElevation
            fullWidth
            sx={{
              bgcolor: "#0085FD",
              color: "white",
              py: 1.5,
              borderRadius: "10px",
              textTransform: 'none',
              fontSize: '1rem',
              fontWeight: 600,
              mb: 4,
              "&:hover": { bgcolor: "#0072DB" }
            }}
          >
            Save & Next
          </Button>
        </form>
      </Box>
    </>
  );
};

export default UploadDocuments;
